// Copyright (c) 2017 Deere & Company

import auditStatus from './audit-status';
import auditSummary from './audit-summary';
import laborRateHistory from './labor-rate-history';
import laborStats from './labor-stats';
import openPartRequests from './open-part-requests';
import openPips from './open-pips';
import pipHistory from './pip-history';
import questionablePart from './questionable-part-search';
import specialAllowanceClaimStatus from './special-allowance-claim-status';

export default {
    childRoutes: [
        auditStatus,
        auditSummary,
        laborRateHistory,
        laborStats,
        openPartRequests,
        openPips,
        pipHistory,
        questionablePart,
        specialAllowanceClaimStatus
    ]
};



// WEBPACK FOOTER //
// ./src/routes/tcsm/reports/index.js